import JsBarcode from "jsbarcode";

export const barcodeFormatFor = (value) => {
  const digits = String(value || "").replace(/\D/g, "");
  return /^\d{13}$/.test(digits) ? "EAN13" : "CODE128";
};

export const buildProductLabelHtml = (product) => {
  const name = (product.name || product.title || "Produit").slice(0, 40);
  const price = Number(product.price || 0).toFixed(2);
  const barcodeValue = escapeJsBarcode(product.barcode || product.sku || "");
  const fallbackText = product.barcode || product.sku || product.id || "";
  const barcodeId = `barcode-${Date.now()}`;
  const barcodeFormat = barcodeFormatFor(barcodeValue);

  const barcodeBlock = barcodeValue
    ? `
  <div class="barcode"><svg id="${barcodeId}"></svg></div>`
    : `
  <div class="no-barcode">${escapeHtml(fallbackText || "SANS CODE-BARRES")}</div>`;

  return `<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8">
<title>Etiquette - ${name}</title>
<script src="https://cdn.jsdelivr.net/npm/jsbarcode@3.11.6/dist/JsBarcode.all.min.js"><\/script>
<style>
  @page { size: 50mm 30mm; margin: 2mm; }
  * { margin: 0; padding: 0; box-sizing: border-box; }
  body { font-family: Arial, Helvetica, sans-serif; width: 50mm; height: 30mm; display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 2mm; }
  .label { width: 100%; height: 100%; display: flex; flex-direction: column; align-items: center; justify-content: center; border: 0.3px solid #ccc; border-radius: 2mm; padding: 1.5mm; }
  .product-name { font-size: 10px; font-weight: 700; text-align: center; line-height: 1.2; max-height: 6.5mm; overflow: hidden; width: 100%; }
  .barcode { width: 100%; max-height: 9mm; margin-top: 1mm; }
  .barcode svg { width: 100%; height: 100%; }
  .no-barcode { font-size: 8px; color: #555; text-align: center; margin-top: 1mm; padding: 1mm 0; border: 0.5px dashed #aaa; border-radius: 1mm; width: 100%; }
  .price { font-size: 16px; font-weight: 800; margin-top: 1mm; }
</style>
</head>
<body>
<div class="label">
  <div class="product-name">${escapeHtml(name)}</div>
  ${barcodeBlock}
  <div class="price">${escapeHtml(price)} EUR</div>
</div>
${
  barcodeValue
    ? `<script>
  JsBarcode("#${barcodeId}", "${barcodeValue}", {
    format: "${barcodeFormat}",
    width: 1.2,
    height: 25,
    displayValue: true,
    fontSize: 8,
    margin: 0,
    textMargin: 1
  });
  setTimeout(function() { window.print(); }, 500);
<\/script>`
    : `<script>
  setTimeout(function() { window.print(); }, 300);
<\/script>`
}
</body>
</html>`;
};

const escapeHtml = (str) =>
  String(str)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");

const escapeJsBarcode = (str) =>
  String(str).replace(/[^a-zA-Z0-9\-_. ]/g, "");

export const printProductLabel = (product) => {
  const html = buildProductLabelHtml(product);
  const printWindow = window.open("", "_blank", "width=200,height=120");
  if (printWindow) {
    printWindow.document.write(html);
    printWindow.document.close();
  }
};

export const printLotLabel = (lot, productName) => {
  const name = (productName || "Produit").slice(0, 40);
  const lotCode = lot.lotCode || "";
  const quantity = lot.quantity || "";
  const unitType = lot.unitType || "piece";
  const expiry = lot.expiryDate || "";
  const supplier = lot.supplierName || "";
  const barcodeId = `lot-barcode-${Date.now()}`;

  const html = `<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8">
<title>Etiquette Lot - ${lotCode}</title>
<script src="https://cdn.jsdelivr.net/npm/jsbarcode@3.11.6/dist/JsBarcode.all.min.js"><\/script>
<style>
  @page { size: 50mm 30mm; margin: 2mm; }
  * { margin: 0; padding: 0; box-sizing: border-box; }
  body { font-family: Arial, Helvetica, sans-serif; width: 50mm; height: 30mm; display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 2mm; }
  .label { width: 100%; height: 100%; display: flex; flex-direction: column; align-items: center; justify-content: center; border: 0.3px solid #ccc; border-radius: 2mm; padding: 1.5mm; }
  .lot-name { font-size: 6px; font-weight: 600; text-align: center; line-height: 1.1; max-height: 4mm; overflow: hidden; width: 100%; }
  .lot-code { font-size: 7px; font-weight: 700; text-align: center; }
  .barcode { width: 100%; max-height: 8mm; }
  .barcode svg { width: 100%; height: 100%; }
  .info { font-size: 5.5px; text-align: center; color: #555; margin-top: 0.3mm; }
</style>
</head>
<body>
<div class="label">
  <div class="lot-name">${escapeHtml(name)}</div>
  <div class="lot-code">${escapeHtml(lotCode)}</div>
  <div class="barcode"><svg id="${barcodeId}"></svg></div>
  <div class="info">${escapeHtml(quantity)} ${escapeHtml(unitType)}${supplier ? " | " + escapeHtml(supplier) : ""}${expiry ? " | Exp: " + escapeHtml(expiry) : ""}</div>
</div>
<script>
  JsBarcode("#${barcodeId}", "${escapeHtml(lotCode)}", {
    format: "CODE128",
    width: 1,
    height: 20,
    displayValue: true,
    fontSize: 7,
    margin: 0,
    textMargin: 1
  });
  setTimeout(function() { window.print(); }, 500);
<\/script>
</body>
</html>`;

  const printWindow = window.open("", "_blank", "width=200,height=120");
  if (printWindow) {
    printWindow.document.write(html);
    printWindow.document.close();
  }
};
